import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=62d612c3&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=ts&"
export * from "./AppMain.vue?vue&type=script&lang=ts&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=62d612c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d612c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62d612c3')) {
      api.createRecord('62d612c3', component.options)
    } else {
      api.reload('62d612c3', component.options)
    }
    module.hot.accept("./AppMain.vue?vue&type=template&id=62d612c3&scoped=true&", function () {
      api.rerender('62d612c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/layout/components/AppMain.vue"
export default component.exports